import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PostLaunchTruth } from './components/PostLaunchTruth';
import { InvisibleReaders } from './components/InvisibleReaders';
import { GenericNextSteps } from './components/GenericNextSteps';
import { MechanismVisual } from './components/MechanismVisual';
import { ReaderValue } from './components/ReaderValue';
import { BusinessValue } from './components/BusinessValue';
import { Offer } from './components/Offer';
import { FinishFaqCta } from './components/FinishFaqCta';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { ScoreProvider } from './components/ScoreContext';
export function App() {
  return <ScoreProvider data-id="element-0" data-mp="28tmej1rry8wp">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass-ink selection:text-white" data-id="element-1" data-mp="28t4jg8gum0qd">
        <Nav data-id="element-2" data-mp="23v2sz2h3ez4v" />
        <main data-id="element-3" data-mp="23ti8y6semyl9">
          <Hero data-id="element-4" data-mp="3ijxoypkvdyjd" />
          <PostLaunchTruth data-id="element-5" data-mp="3ikh98cxzsz0k" />
          <InvisibleReaders data-id="element-6" data-mp="3ij65ue8glt9z" />
          <GenericNextSteps data-id="element-7" data-mp="3ihv1ac76whht" />
          <MechanismVisual data-id="element-8" data-mp="3mlat8v8bdto6" />
          <ReaderValue data-id="element-9" data-mp="3mkhou0wtvg97" />
          <BusinessValue data-id="element-10" data-mp="3mjq2zht18ww4" />
          <Offer data-id="element-11" data-mp="3rc9du70c5dx8" />
          <FinishFaqCta data-id="element-12" data-mp="3rbra6pbcfxfa" />
        </main>
        <Footer data-id="element-13" data-mp="3rcsyvwla8ifh" />
        <StickyWidget data-id="element-14" data-mp="3recdzjv7cnfo" />
        <Diagnostic data-id="element-15" data-mp="5yhgo69t1c8" />
      </div>
    </ScoreProvider>;
}